import React from 'react';

export const Policies = [
  {
    title: 'Terms of Use',
    content: <p>Terms of USe</p>,
  },
  {
    title: 'Privacy Policy',
    content: <p>Privacy Policy</p>,
  },
  {
    title: 'Service Terms',
    content: <p>Service Terms</p>,
  },
];
